The additional `PositionOpening`-specific criteria to filter by.
